import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gradient-to-r from-slate-50 to-blue-50 border-b border-slate-200 p-4 sm:p-6 min-w-0" }
const _hoisted_2 = { class: "flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between min-w-0" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row gap-3 sm:gap-4 w-full min-w-0 xl:flex-1" }
const _hoisted_4 = { class: "w-full min-w-0 sm:flex-1 sm:max-w-xl lg:max-w-2xl" }
const _hoisted_5 = { class: "hidden sm:flex items-center gap-2 bg-white px-3 py-2 rounded-xl border border-blue-200 shadow-sm flex-shrink-0" }
const _hoisted_6 = { class: "text-lg font-bold text-blue-600 tabular-nums" }
const _hoisted_7 = { class: "flex flex-wrap gap-3 items-stretch sm:items-end min-w-0 xl:flex-shrink-0" }
const _hoisted_8 = { class: "min-w-[10rem] flex-1 sm:flex-none sm:w-44" }
const _hoisted_9 = { class: "min-w-[8rem] flex-1 sm:flex-none sm:w-36" }

import AdminFormSearchInput from "@/share/components/admin/AdminFormSearchInput.vue";
import AdminFormSelectField, {
  type AdminSelectOption,
} from "@/share/components/admin/AdminFormSelectField.vue";
import { computed } from "vue";

interface Props {
  search?: string;
  visibility: number | undefined;
  limit?: number;
  total: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'filtrosComponents',
  props: {
    search: {},
    visibility: {},
    limit: {},
    total: {}
  },
  emits: ["search", "visibilityFilter", "limitChange", "refresh"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visibilityStr = computed(() =>
  props.visibility === undefined || props.visibility === null
    ? ""
    : String(props.visibility)
);

const limitStr = computed(() => String(props.limit ?? 10));

const visibilityOptions = computed<AdminSelectOption[]>(() => [
  { value: "", label: "Todas" },
  { value: "1", label: "Visibles" },
  { value: "0", label: "Ocultas" },
]);

const limitOptions: AdminSelectOption[] = [
  { value: "5", label: "5" },
  { value: "10", label: "10" },
  { value: "25", label: "25" },
  { value: "50", label: "50" },
  { value: "100", label: "100" },
];

const onVisibilityStr = (v: string) => {
  emit("visibilityFilter", v === "" ? undefined : Number(v));
};

const onLimitStr = (v: string) => {
  emit("limitChange", Number(v));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(AdminFormSearchInput, {
            "input-id": "filtros-catalogo-search",
            "model-value": __props.search ?? '',
            placeholder: "Buscar por nombre o descripción…",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('search', $event)))
          }, null, 8, ["model-value"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-sm font-medium text-slate-600" }, "Total", -1)),
          _createElementVNode("span", _hoisted_6, _toDisplayString(__props.total), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(AdminFormSelectField, {
            "select-id": "filtros-catalogo-visibilidad",
            label: "Visibilidad",
            "model-value": visibilityStr.value,
            options: visibilityOptions.value,
            "onUpdate:modelValue": onVisibilityStr
          }, null, 8, ["model-value", "options"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(AdminFormSelectField, {
            "select-id": "filtros-catalogo-limit",
            label: "Por página",
            "model-value": limitStr.value,
            options: limitOptions,
            "onUpdate:modelValue": onLimitStr
          }, null, 8, ["model-value"])
        ])
      ])
    ])
  ]))
}
}

})